var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTon56(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 48c11.046 0 20-8.954 20-20S39.046 8 28 8 8 16.954 8 28s8.954 20 20 20Z",
    fill: "#309FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.435 21.217h11.217c.397 0 .794.059 1.208.252.497.231.76.596.945.866a2.517 2.517 0 0 1 .37 1.317c-.001.426-.102.89-.33 1.296l-.006.011-7.087 12.174a.87.87 0 0 1-1.506-.005L20.288 24.98l-.006-.01c-.16-.262-.406-.668-.449-1.192a2.373 2.373 0 0 1 1.355-2.34c.47-.219.946-.22 1.246-.22Zm4.696 1.74h-4.696c-.309 0-.427.018-.51.057a.622.622 0 0 0-.358.622c.006.074.037.158.214.451l.011.019 5.338 9.321v-10.47Zm1.739 0v10.516l5.461-9.382a.949.949 0 0 0 .104-.439.772.772 0 0 0-.09-.37 1.404 1.404 0 0 0-.138-.178.255.255 0 0 0-.082-.059 1.04 1.04 0 0 0-.473-.089H28.87Z",
    fill: "#fff"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTon56);
export default __webpack_public_path__ + "static/media/ton_56.dfad6c6e.svg";
export { ForwardRef as ReactComponent };